import React from "react";
import { shape, string, arrayOf, bool } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { SocialFollowButtons } from "./SocialFollowButtons";
// eslint-disable-next-line import/no-cycle
import { SocialFollowButtonsCTA } from "./SocialFollowButtonsCTA/SocialFollowButtonsCTA";

const SocialFollowButtonsConnector = ({ data }) =>
	data.displayAsCta ? (
		<SocialFollowButtonsCTA
			ctaTitle={data.ctaTitle}
			facebookPageLink={data.facebookPageLink}
			instagramPageLink={data.instagramPageLink}
			twitterPageLink={data.twitterPageLink}
			pinterestPageLink={data.pinterestPageLink}
			youTubePageLink={data.youTubePageLink}
		/>
	) : (
		<SocialFollowButtons
			facebookPageLink={data.facebookPageLink}
			instagramPageLink={data.instagramPageLink}
			twitterPageLink={data.twitterPageLink}
			pinterestPageLink={data.pinterestPageLink}
			youTubePageLink={data.youTubePageLink}
			tags={data.tags}
		/>
	);

SocialFollowButtonsConnector.propTypes = {
	data: shape({
		facebookPageLink: string,
		instagramPageLink: string,
		twitterPageLink: string,
		pinterestPageLink: string,
		youTubePageLink: string,
		tags: arrayOf(string),
		displayAsCta: bool,
		ctaTitle: string,
	}),
};
SocialFollowButtonsConnector.defaultProps = {
	data: null,
};

export default SocialFollowButtonsConnector;
export { SocialFollowButtonsConnector };
